import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import user from './modules/user';
import objectsites from './modules/objectsites';
import objectsetup from './modules/objectsetup';
import sidebar from './modules/sidebar';
import tagger from './modules/tagger';
import dashboard from './modules/dashboard';
import sidebarhistory from './modules/sidebarhistory';
import objectstati from './modules/objectstati';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		global,
		user,
		objectsites,
		objectsetup,
		objectstati,

		sidebar,
		sidebarhistory,
		tagger,
		dashboard,
	},
});



// WEBPACK FOOTER //
// ./src/store/index.js